import { useEffect, useRef } from 'react';

export function useEffectOnce(cb: () => unknown) {
  const executed = useRef<boolean>(false);

  useEffect(() => {
    if (!executed.current) {
      cb();
      executed.current = true;
    }
  }, [cb]);
}
